import { render, staticRenderFns } from "./bulk-message-recipients-import-upload.vue?vue&type=template&id=de1e6e82&scoped=true&"
import script from "./bulk-message-recipients-import-upload.vue?vue&type=script&lang=js&"
export * from "./bulk-message-recipients-import-upload.vue?vue&type=script&lang=js&"
import style0 from "./bulk-message-recipients-import-upload.vue?vue&type=style&index=0&id=de1e6e82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1e6e82",
  null
  
)

export default component.exports